import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import indexRoutes from "routes/index.jsx";

import "assets/scss/material-dashboard-pro-react.css?v=1.4.0";

import axios from 'axios'
import {logOut} from "./assets/helpers/loginHelper";
import {refreshToken} from "./assets/helpers/loginHelper";

const hist = createBrowserHistory();
// Add a 401 response interceptor
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    logOut()
    return Promise.reject(error);
  } else {
    return Promise.reject(error);
  }
});

refreshToken()

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} component={prop.component} key={key}/>;
      })}
    </Switch>
  </Router>,
  document.getElementById("root")
);
